import React, { useEffect, useState, useContext } from 'react';
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import DocumentView from 'components/sales/downloadDocView/documentView';

const AssetMappingInfo = ({
  history,
  match,
  getAssetsInfoData,
  assetsInfo
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [gateInfo, setGateInfo] = useState("");
  const [assetInfoData, setAssetInfo] = useState([]);

  useEffect(() => {
    if(match.params.gate_id && match.params.asset_mapping_id) {
        (async () => {
            setIsLoading(true);
            await getAssetsInfoData(match.params.gate_id,match.params.asset_mapping_id);
            setIsLoading(false);
        })();
    }
  },[match.params.gate_id,match.params.asset_mapping_id]);

  console.log('PAGE:: ASSET MAPPING INFO');
  useEffect(() => {
    if(assetsInfo && assetsInfo != null && assetsInfo != undefined) {
        setGateInfo(assetsInfo?.gateInfo);
        setAssetInfo(assetsInfo?.result);
    }
  },[assetsInfo]);
  //console.log('AssetInfo ' + JSON.stringify(assetInfoData));
  return (
    <Layout
      title={localization.assetMappingInfo}
      isLoading={isLoading}
      isGoback
      //linkUrl={`${baseUrl}/new-site-asset-mapping/${match.params.site_id}/${match.params.lead_id}`}
    >
     <CardSection title={`Gate Info`} clsName={'mh1'}>
      <div className="details-listing">
        <DivLayout
            heading={localization.gate}
            data={gateInfo?.gate_name}
        />
        <DivLayout
            heading={localization.identifier}
            data={gateInfo?.identifier}
        />
        <DivLayout
            heading={localization.remark}
            data={gateInfo?.remark}
        />
        <DivLayout
            heading={localization.assetMappedBy}
            data={gateInfo?.created_by}
        />
          {gateInfo?.photo !== undefined && gateInfo?.photo.length  > 0  &&
            <>
                {gateInfo?.photo.map((v,  i) => {
                    return (
                        <>
                            <DocumentView attachment={v} title='Photo' />
                        </>
                    )
                })}
            </>
          }

      </div>
     </CardSection>
      {assetInfoData && assetInfoData.length > 0 && assetInfoData.map((value,key) => {
        return (
        <>    
        <CardSection title={`Material`} clsName='mh2'>
        <div className="details-listing">   
            <DivLayout
                heading={localization.material}
                data={value['mat_name']}
            />
            <DivLayout
                heading={localization.make}
                data={value['make_name']}
            />
            <DivLayout
                heading={localization.barcode}
                data={value['barcode']}
            />
            {value?.photo !== undefined && value?.photo.length  > 0  &&
                <>
                    {value?.photo.map((v,  i) => {
                        return (
                            <>
                                <DocumentView attachment={v} title='Photo' />
                            </>
                        )
                    })}
                </>
            }
            {value && value['child'] !== undefined && value['child'].length > 0 ? (  
            <>
                {value['child'].map((v,i) => {
                    return (
                    <div class="">
                        <CardSection title={`Child Material`} clsName='mh3'>  
                            <div className="details-listing">
                            <DivLayout
                                heading={localization.material}
                                data={v['mat_name']}
                            />
                            <DivLayout
                                heading={localization.make}
                                data={v['make_name']}
                            />
                            <DivLayout
                                heading={localization.barcode}
                                data={v['barcode']}
                            />
                            <DivLayout
                                heading={localization.specification}
                                data={v['specification']}
                            />
                                {v?.photo !== undefined && v?.photo.length  > 0  &&
                                    <>
                                        {v?.photo.map((photo,  i) => {
                                            return (
                                                <>
                                                    <DocumentView attachment={photo} title='Photo' />
                                                </>
                                            )
                                        })}
                                    </>
                                }
                            {/*<DocumentView attachment={v['photo']} title='Photo' />*/}
                            </div>
                        </CardSection>
                    </div>
                    ) 
                })}
            </>
            ):null}

        </div>
        </CardSection>       
        </>
        )
      })}
    </Layout>
  );
};

export default AssetMappingInfo;
